import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Subject } from 'rxjs/Subject';

import { AuthService } from '../../../auth/auth.service';
import { SearchService } from '../../../../features/search/search.service';

import { User } from '../../../user/user.model';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: [ './topbar.component.scss' ]
})
export class TopbarComponent implements OnInit, AfterViewInit, OnDestroy {
  currentUser: User = this.authService.currentUser;
  outstandingTasksCount: number = 0;
  keepSubscriptionsAlive: boolean = true;
  searchTerm$ = new Subject<string>();
  results: any;

  get isExternalUser() {
    return this.authService.isExternalUser();
  }

  constructor(private readonly authService: AuthService,
              private readonly searchService: SearchService,
              private readonly router: Router) {
  }

  ngOnInit() {
    this.searchService
      .searchCompanies(this.searchTerm$)
      .takeWhile(() => this.keepSubscriptionsAlive)
      .subscribe(results => this.searchService.foundCompanies = results);

    this.searchService
      .searchContacts(this.searchTerm$)
      .takeWhile(() => this.keepSubscriptionsAlive)
      .subscribe(results => this.searchService.foundContacts = results);

    this.searchService
      .searchProjects(this.searchTerm$)
      .takeWhile(() => this.keepSubscriptionsAlive)
      .subscribe(results => {
        this.searchService.foundOpportunities = results;
        this.searchService.foundDeals = results.filter(p => p.isDeal);
      });
  }

  ngAfterViewInit() {
    this.currentUser = this.authService.currentUser;
    this.outstandingTasksCount = this.currentUser[ 'tasks' ].reduce(function (tally, task) {
      return task.status !== 'Completed' ? tally + 1 : tally;
    }, 0);
  }

  ngOnDestroy() {
    this.keepSubscriptionsAlive = false;
  }

  onSearch(event) {
    this.searchTerm$.next(event.target.value);
    this.router.navigate([ '/search' ]);
  }
}



// WEBPACK FOOTER //
// ./client/app/core/layout/secure/topbar/topbar.component.ts